// extracted by mini-css-extract-plugin
export var header = "styles-module--header--CXdl2";
export var headerContent = "styles-module--headerContent--mkKcl";